export const ugovor_o_komisiji = {
    templateId: 212,
    category: 16,
    templateTitle: 'Ugovor o komisionoj prodaji robe',
    templateDescription: `<p>Ugovorom o komisiji komisionar se obvezuje uz proviziju obaviti jedan ili više poslova u svoje ime, a za račun komitenta, pri čemu komisionar ima pravo na proviziju i kad nije ugovorena. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o komisiji, komisionar se obvezuje u svoje ime, a za račun komitenta, uz proviziju obaviti jedan ili više poslova.    </p>
    <p>Ugovor o komisiji, najčešće se zaključuje kao ugovor o komisionoj prodaji robe prema kojemu komitent (vlasnik robe) predaje komisionaru (trgovačkom posredniku) robu, dok komisionar u svoje ime prodaje dalje robu trećim osobama, a za račun komitenta.</p>
    <p>Predložak takvog ugovora daje se u nastavku ovog uvodnog teksta.</p>
    <p>Pri komisionoj prodaji, roba ostaje u vlasništvu komitenta (vlasnika robe), sve do trenutka prodaje trećoj osobi od strane komisionara (trgovačkog posrednika). </p>
    <p>Iznos ostvaren prodajom pripada komitentu, a komitent se obvezuje za takvu prodaju, komisionaru isplatiti proviziju.    </p>
    <p>Takva provizija najčešće se ugovara kao postotak od ostvarene prodajne cijene. </p>
    <p>Budući da se odnos komisionara i komitenta temelji na nalogu, glavna obveza komisionara je sklapati odnosno sklopiti poslove određene nalogom komitenta.     </p>
    <p>Ukoliko komisionar proda robu po nepovoljnijim uvjetima od uvjeta određenih nalogom komitenta, dužan je komitentu naknaditi razliku odnosno naknaditi štetu. </p
    <p>S druge strane gledajući, ako komisionar sklopi posao po povoljnijim uvjetima od uvjeta određenih nalogom komitenta, sva postignuta korist ipak pripada komitentu.  </p>
    <p><strong>Pri prodaji robe u komisiji (robe komitenta), komisionar ispostavlja račun trećoj osobi,  kao i pri prodaji vlastite robe, dok vlasniku robe (komitentu) polaže račun prodane robe.</strong> </p>
    <p>Budući da pri prodaji robe u  komisiji nastaju dvije isporuke:    </p>
    <ul>
    <li> isporuka komitenta (vlasnika robe) komisionaru,</li>
    <li> isporuka komisionara kupcu,</li>
    </ul>
    <p>porezne obveze u tom smislu nastaju u istom obračunskom razdoblju.  </p>
    <p>Važno je naglasiti da komitent (vlasnik robe) može biti i fizička osoba koja ne obavlja djelatnost, a ne samo pravna osoba odnosno osoba koja obavlja djelatnost.    </p>
    <p>Komisionar (trgovački posrednik) mora biti trgovac, jer su komisijske usluge sastavni dio usluge posredovanja u trgovini.     </p>
    <p>Na ugovor o komisiji na odgovarajući se način primjenjuju odredbe Zakona o obveznim odnosima koji reguliraju nalog.    </p>
    <p>Također, zakonom je propisano da komisionar ima pravo na proviziju i kad nije ugovorena.  </p>
    <br>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima, Zakon o trgovini.</p>

  `,

    sides: [
        {
            signature: 'Komitent:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Komitent)',
            delimiter: `i`
        },
        {
            signature: 'Komisionar:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Komisionar),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O KOMISIONOJ PRODAJI ROBE',
    noArticleNumbers: false,

    articles: [

      {
        title: 'PREDMET UGOVORA',
        mandatory: true,
        exampleContent: true, 
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Komisionar se obvezuje da će za naknadu/proviziju obavljati prodaju _________ (dalje u tekstu: roba), u svoje ime, a za račun Komitenta, prema robi koje mu povjeri Komitent.',
                value: '',
            }],
    },

    {
      title: 'ČUVANJE ROBE      ',
      mandatory: false,
      statements: [
          {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Komisionar se obvezuje obavljati poslove prodaje povjerene mu robe u svojim prodajnim prostorima te čuvati robu pažnjom dobrog gospodarstvenika.',
              value: '',
          }],
  },
  {
    title: "OSIGURANJE ROBE",
    mandatory: false,
    exampleContent: true, 
    statements: [
      {
        type: "choice",
        mandatory: true,
        editable: true,
        choices: [
          "Komisionar nije dužan osigurati robu koja je predmet komisione prodaje.",
          "Komisionar je dužan osigurati  robu protiv požara i provalne krađe, a u slučaju da to ne učini, odgovara Komitentu za slučajnu propast ili oštećenje robe."
        ],
        placeholder: "Odaberite ovdje te potom izmijenite po želji...",
      }]
  },
  {
    title: 'PREDAJA I PREGLED ROBE   ',
    mandatory: false,
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Prilikom preuzimanja robe od Komitenta, Komisionar će pregledati robu te o eventualnim nedostacima u kvaliteti odnosno kvantiteti bez odlaganja obavijestiti Komitenta. \r\nUkoliko Komisionar bez odlaganja ne obavijesti Komitenta o nedostacima, smatrati će se da je robu preuzeo u ispravnom stanju, bez manjkova i oštećenja. ',
            value: '',
        }],
},
{
  title: 'OBAVIJEST O PROMJENAMA  ',
  mandatory: false,
  exampleContent: true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Komisionar je dužan bez odgode, obavijestiti Komitenta o svim promjenama na robi zbog kojih bi ona mogla izgubiti na svojoj vrijednosti. \r\nAko nema vremena za čekanje Komitentovih uputa ili Komitent odugovlači s uputama, u slučaju da prijeti opasnost znatnijeg oštećenja robe, Komisionar je dužan prodati robu na najpovoljniji način.',
          value: '',
      }],
},
{
  title: 'ZASTUPANJE INTERESA KOMITENTA ',
  mandatory: false,
  exampleContent: true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Komisionar je dužan postupiti po Komitentovom nalogu i u svemu se pridržavati njegovih uputa, postupajući s pažnjom dobrog gospodarstvenika.\r\nKomisionar je dužan u svemu paziti na Komitentove interese.          ',
          value: '',
      }],
},
{
  title: "PRIOPĆAVANJE KOMITENTU KUPCA  ",
  mandatory: false,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Komisionar je dužan priopćiti Komitentu s kojom je osobom obavio posao što mu ga je Komitent povjerio.",
        "S obzirom na je predmet komisione prodaje, prodaja pokretnih stvari u prodavaonicama Komisionara, Komisionar nije dužan priopćiti Komitentu osobe s kojima je posao obavio."
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "PROVIZIJA ",
  mandatory: true,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Komitent se obvezuje Komisionaru platiti proviziju u razlici između cijene izražene na otpremnici/komisijskog dostavnici i ostvarene kupoprodajne cijene Komisionara.         ",
        "Komitent se obvezuje Komisionaru platiti proviziju u visini od ..... % od vrijednosti prodane robe.        "
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "POSEBNO JAMSTVO ZA ISPUNJENJE OBVEZE KUPCA ",
  mandatory: false,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Komisionar ne jamči za ispunjenje obveza kupca po osnovi komisione prodaje robe.",
        "Komisionar jamči da će kupac ispuniti svoje obveze po osnovi komisione prodaje robe te solidarno odgovara Komitentu za ispunjenje (delkredere komisija), stoga ima pravo i na povećanu proviziju (delkredere provizija) od ___________."
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "PROVIZIJA ZA PRODANU ROBU SA SKRIVENIM NEDOSTACIMA  ",
  mandatory: false,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Ugovorne strane suglasno utvrđuju da Komisionar ima pravo na naknadu i za robu koju je kupac vratio zbog skrivenih nedostataka.        ",
        "Ugovorne strane suglasno utvrđuju da Komisionar nema pravo na naknadu i za robu koju je kupac vratio zbog skrivenih nedostataka.        "
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "OBRAČUN ",
  mandatory: true,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Komisionar se obvezuje najkasnije do svakog petnaestog u mjesecu obračunati obavljene poslove (izvršene prodaje) te dostaviti Komitentu obračun sklopljenih poslova.        ",
        "Komisionar je dužan obračunati obavljene poslove (izvršene prodaje) te dostaviti Komitentu obračun sklopljenih poslova tromjesečno, prvog radnog dana poslije sljedećih datuma, 31. ožujka, 30.lipnja, 30.rujna i 31. prosinca tekuće godine.  ",
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "ISPLATE PRIMLJENIH SREDSTAVA I PROVIZIJE  ",
  mandatory: true,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Komisionar se obvezuje po izvršenom obračunu predati Komitentu sve što je primio po osnovi obavljenih poslova te primljena sredstva uplatiti na račun Komisionara, a Komitent se obvezuje isplatiti proviziju Komisionaru u roku od ___ dana o primitka novčanih sredstava i pisanog izvješća o obavljenim poslovima.",
        "Komisionar se obvezuje po izvršenom obračunu predati Komitentu sve što je primio po osnovi obavljenih poslova za račun Komitenta umanjeno za proviziju.    ",

      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: "TROŠKOVI ",
  mandatory: true,
  exampleContent: true, 
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Komitent je dužan naknaditi Komisionaru troškove koji su bili potrebni za izvršenje naloga (troškovi prijevoza, promidžbe i sl.) u svrhu prodaje robe, s kamatama od dana kad su učinjeni, dok je naknada za uporabu Komisionarovih skladišta i transportnih sredstava obuhvaćena provizijom.",
        "Komisionar se odriče potraživati od Komitenta bilo kakve troškove po osnovi komisije.        ",

      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }]
},
{
  title: 'OBAVIJEST O NEPRODANOJ ROBI',
  mandatory: false,
  exampleContent: true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'U slučaju da Komisionar ne proda robu Komitenta, o svim neprodanim količinama robe Komitenta, Komisionar će ga obavijestiti najkasnije ___ od preuzimanja, a najkasnije do 01. ožujka svake pojedine godine. \r\nUkoliko Komitent to zatraži, neprodanu robu ili njezin dio Komisionar će vratiti Komitentu u svako doba.          ',
          value: '',
      }],
},
{
  title: 'ZALOŽNO PRAVO  ',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Ugovorne strane su suglasne da Komisionar ima založno pravo na robi Komitenta, koja je predmet ugovora o komisiji, dok se ona nalazi kod njega ili kod nekog tko je drži za njega ili dok ima ispravu s pomoću koje može raspolagati s predmetnom robom.          ',
          value: '',
      }],
},
{
  title: 'TRAJANJE UGOVORA',
  mandatory: true,
  statements: [
      {
          type: 'choice',
          mandatory: true,
          editable: false,
          choices: [
              {
                  parts: [
                      {type: 'text', content: 'Ovaj ugovor se zaključuje na neodređeno vrijeme.'},
                 ]
              },
              {
                  parts: [
                      {type: 'text', content: 'Ovaj ugovor se zaključuje na određeno vrijeme i traje od'},
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: 'do'},
                      {type: 'input', value: '', required: true},
                 ]
              },
             ],
          value: '',
      }
  ]
},
{
  title: 'OTKAZ UGOVORA  ',
  mandatory: false,
  exampleContent:true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Svaka ugovorna strana može otkazati ugovor bez obrazloženja uz otkazni rok od 15 dana. \r\nU slučaju otkaza ugovora ugovorne strane će sačiniti konačni obračun međusobnih obveza i potraživanja, a potraživanja iz takvog konačnog obračuna dospijevaju u roku od 15 dana po potpisu obračuna.           ',
          value: '',
      }],
},

{
    title: 'MJERODAVNO PRAVO',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: false,
            content: 'Na prava i obveze ugovornih stranaka, koja nisu posebno uređena ovim Ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima.',
            value: '',
        }],
},
{
    title: 'NADLEŽNOST',
    mandatory: false,
    statements: [
        {
            type: 'choice',
            mandatory: true,
            editable: false,
            choices: [
                {
                    parts: [
                        {
                            type: 'text',
                            content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Komisionara.'
                        }
                    ]
                },
                {
                    parts: [
                        {
                            type: 'text',
                            content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Komitenta.'
                        }
                    ]
                },
                {
                    parts: [
                        {
                            type: 'text',
                            content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                        },
                        {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                        ]
                }
            ],
            value: '',
        }
    ]
},
{
    title: 'PRIMJENA UGOVORA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
            value: '',
        }],
},
{
    title: 'PRIMJERCI UGOVORA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
            value: '',
        }],
  },
{
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures
    statements: [],
}
],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/212_ugovor_o_komisiji.ts